// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3KnSx","boxTitle":"Qualiphy_boxTitle__24TLv","box":"Qualiphy_box__LTcDV","toggleWrap":"Qualiphy_toggleWrap__LVZTE"};